import ky from "ky";

import Api from "@repo/api";

import RestApi from "./RestApi";

export default RestApi.create<
  | GlobImport<
      "./kikoffAdminApi/api/**/*.ts",
      { trimStart: "./kikoffAdminApi/api/"; trimEnd: ".ts" }
    >
  // prettier-ignore
  | {
/* GENERATED */ "admin-info": import("./kikoffAdminApi/api/admin-info.ts").default,
/* GENERATED */ "community": import("./kikoffAdminApi/api/community.ts").default
}
>(`${Api.origin}/internal/api/v1`, ky.create({ credentials: "include" }));
